module.exports = __webpack_public_path__ + "img/s_7.53105371.png";